import jQuery from 'jquery'

class MBRibbon {
  constructor(element, mockBackground) {
    if ((!element, !mockBackground)) {
      return false
    }

    this.$element = element
    this.$element2 = mockBackground

    this.ini()

    jQuery(window).on('resize', () => {
      this.ini()
    })

    jQuery(window).on('scroll', () => {
      this.ini()
    })
  }

  ini() {
    const stickyElement = jQuery(this.$element)
    const mockBackground = jQuery(this.$element2)

    mockBackground.css('height', stickyElement.outerHeight())
  }
}
export default MBRibbon
